// ==================== FINANCIAL MODELS ====================

export const FINANCIAL_MODELS = {
  ebitdaImpact: {
    calculationMethod: 'Incremental EBITDA = Revenue Uplift + Cost Reduction - Implementation Cost',
    byScale: {
      startup: {
        annualRevenue: 1000000,
        annualCost: 700000,
        ebitda: 300000,
        ebitdaMargin: 0.30,
        aiInvestment: 100000,
        expectedRevenueUplift: 0.15,
        expectedCostReduction: 0.20,
        expectedEBITDAImprovement: 0.05
      },
      smb: {
        annualRevenue: 10000000,
        annualCost: 7000000,
        ebitda: 3000000,
        ebitdaMargin: 0.30,
        aiInvestment: 500000,
        expectedRevenueUplift: 0.15,
        expectedCostReduction: 0.20,
        expectedEBITDAImprovement: 0.05
      },
      enterprise: {
        annualRevenue: 100000000,
        annualCost: 70000000,
        ebitda: 30000000,
        ebitdaMargin: 0.30,
        aiInvestment: 5000000,
        expectedRevenueUplift: 0.15,
        expectedCostReduction: 0.20,
        expectedEBITDAImprovement: 0.05
      }
    }
  },
  
  roiModels: {
    conservative: {
      revenueUplift: 0.10,
      costReduction: 0.15,
      timeframe: 24,
      discountRate: 0.10
    },
    moderate: {
      revenueUplift: 0.15,
      costReduction: 0.20,
      timeframe: 18,
      discountRate: 0.10
    },
    aggressive: {
      revenueUplift: 0.25,
      costReduction: 0.30,
      timeframe: 12,
      discountRate: 0.10
    }
  },
  
  workingCapital: {
    components: {
      inventory: {
        optimizationLevers: ['Demand Forecasting', 'Just-in-Time', 'Safety Stock Optimization'],
        expectedReduction: 0.25,
        cashRelease: 'High'
      },
      receivables: {
        optimizationLevers: ['Payment Prediction', 'Collection Prioritization', 'Credit Scoring'],
        expectedReduction: 0.20,
        cashRelease: 'Medium'
      },
      payables: {
        optimizationLevers: ['Supplier Negotiation', 'Payment Terms Optimization', 'Early Payment Discounts'],
        expectedImprovement: 0.15,
        cashRelease: 'Medium'
      }
    }
  },
  
  costOptimization: {
    categories: [
      { category: 'Labor', aiImpact: '30-40% reduction', automationPotential: 'High' },
      { category: 'Technology', aiImpact: '20-30% optimization', automationPotential: 'Medium' },
      { category: 'Operations', aiImpact: '25-35% reduction', automationPotential: 'High' },
      { category: 'Supply Chain', aiImpact: '15-25% optimization', automationPotential: 'Medium' }
    ]
  }
};

export const calculateEBITDAImpact = (scale, investment, timeframe) => {
  const baseModel = FINANCIAL_MODELS.ebitdaImpact.byScale[scale] || FINANCIAL_MODELS.ebitdaImpact.byScale.smb;
  
  const revenueUplift = baseModel.annualRevenue * baseModel.expectedRevenueUplift;
  const costReduction = baseModel.annualCost * baseModel.expectedCostReduction;
  const incrementalEBITDA = revenueUplift + costReduction;
  const roi = (incrementalEBITDA / investment) * 100;
  const paybackMonths = Math.round((investment / incrementalEBITDA) * 12);
  
  return {
    revenueUplift,
    costReduction,
    incrementalEBITDA,
    roi,
    paybackMonths,
    npv: incrementalEBITDA * 3 - investment // 3-year NPV
  };
};